import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve para cualquier año de la carrera?',
  answer: 'Sí. Los 6 tomos están ordenados por bloque temático y cubren toda la carrera: desde primer año con anatomía, biología y química, hasta los finales de quinto con salud pública, epidemiología y metodología de investigación. Lo usás según lo que estés cursando en este momento.'
}, {
  question: '¿Los materiales son editables?',
  answer: 'Sí. Los documentos vienen en formatos editables para que puedas adaptarlos a tu cursada, tus TPs y tus parciales. Los modelos resueltos, plantillas y guías son tuyos para personalizar como necesites.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos opciones?',
  answer: 'Los 6 bonos están incluidos en las dos opciones. Si además querés el sistema completo para cuando te recibas — con herramientas de consultorio, cobro profesional e identidad digital — el Megapack + Sistema Título en Mano es la opción más inteligente.'
}, {
  question: '¿Sirve si recién arranqué la carrera?',
  answer: 'Es ideal para eso. El Tomo 1 está pensado específicamente para primer año: anatomía, biología, química y matemática aplicada explicadas con contexto nutricional real. No asume conocimiento previo — te da el marco para entender desde cero y arrancar con confianza.'
}, {
  question: '¿Funciona para estudiar para finales difíciles?',
  answer: 'Sí. Cada tomo incluye ejercicios de autoevaluación, glosario de términos clave y resúmenes por capítulo. El Bono 4 tiene un banco de preguntas tipo final armado con lo que más toman los docentes. Varios estudiantes aprobaron materias que habían recursado usando exactamente eso.'
}, {
  question: '¿Qué pasa si tengo materias con mucho contenido teórico?',
  answer: 'Está pensado para eso. En lugar de darte teoría suelta, cada tomo organiza el contenido con lógica clínica y ejemplos aplicados. Fisiología, Bromatología y Salud Pública — las materias que más asustan — tienen capítulos completos con casos resueltos y guías de estudio paso a paso.'
}, {
  question: '¿Qué diferencia tiene con apuntes o resúmenes del mercado?',
  answer: 'La mayoría de los apuntes que circulan son teoría desorganizada o resúmenes de una sola cátedra. El Megapack Nutrición Carrera Resuelta es un sistema de estudio inverso: arranca por lo que vas a necesitar en el parcial o final, y te da el camino más corto para llegar. Modelos resueltos, banco de preguntas, vademécum de fórmulas y guías por materia — todo en un solo lugar.'
}, {
  question: '¿Por qué elegir el Megapack + Sistema Título en Mano?',
  answer: 'El Megapack te resuelve la carrera. El Sistema Título en Mano le agrega todo lo que necesitás cuando te recibás: cómo armar tu consultorio, cómo cobrar desde el día uno, cómo construir presencia digital y cómo posicionarte como profesional. Si querés terminar la carrera, el Megapack alcanza. Si querés además arrancar fuerte cuando salgas, el combo es la decisión obvia.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,253,244) 100%)'
  }} data-id="element-125">
      <div className="mx-auto max-w-4xl" data-id="element-126">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-127">
          Preguntas <span className="text-green-700" data-id="element-128">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-129">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-130">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(34, 197, 94, 0.5)' : '1px solid rgba(34, 197, 94, 0.15)'
          }} data-id="element-131">
                {/* Question */}
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-132">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#15803d' : '#111827'
              }} data-id="element-133">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#15803d',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-134">
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(34, 197, 94, 0.1)'
            }} data-id="element-135">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-136">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}